import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "checklist"
const ChecklistIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m1.97 5.53 1.06-1.06L5 6.44l3.47-3.47 1.06 1.06L5 8.56 1.97 5.53Zm0 6 1.06-1.06L5 12.44l3.47-3.47 1.06 1.06L5 14.56l-3.03-3.03Zm1.06 4.94-1.06 1.06L5 20.56l4.53-4.53-1.06-1.06L5 18.44l-1.97-1.97ZM21 5H11v2h10V5Zm-10 6h10v2H11v-2Zm10 6H11v2h10v-2Z"
      />
    </svg>
  )
}
export default ChecklistIcon
